import React from "react"

const CategoryResetContext = React.createContext(null)

export default CategoryResetContext
